import { DEFAULT_PARTICIPANTS_LAYOUT, LAYOUT_DOM_ATTR, STORE_NAME } from './constants';
/**
 * Returns the currently selected participants-display layout.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {string}
 */
export function getParticipantsLayout(state) {
    return state[STORE_NAME]?.layout ?? DEFAULT_PARTICIPANTS_LAYOUT;
}
/**
 * Reflects the active layout onto the <html> element as a data attribute so the
 * themed CSS can arrange participants accordingly (mirrors data-theme).
 *
 * @param {string} layout - The layout id.
 * @returns {void}
 */
export function applyParticipantsLayoutToDom(layout) {
    if (typeof document === 'undefined') {
        return;
    }
    document.documentElement.setAttribute(LAYOUT_DOM_ATTR, layout || DEFAULT_PARTICIPANTS_LAYOUT);
}
